<template>
  <v-card flat>
    <v-container :fluid="true" class="px-4">
      <v-row>
        <v-col :cols="3" class="pt-0">
          <file-reader :clearValue="clearFileReader" @load="parseOpticheck($event)" @clear="clearOpticheck($event)"></file-reader>
        </v-col>
        <v-col :cols="9" class="pt-0 text-right">
          <v-btn
            v-show="tabVisible"
            :tooltip="$t('global.datatable.buttons.save')"
            color="primary"
            :icon="true"
            large
            @click="save"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider v-show="tabVisible"></v-divider>
      <v-row xs12>
        <v-col xs12>
          <v-tabs v-model="activeTabHeader" v-show="tabVisible">
            <v-tab v-for="(tab, i) in tabs" :key="tab" @click="activeTab=tab" :tabindex="i">
              {{ tabTitles[i] }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item v-for="(tab, i) in tabs" :key="tab" :value="tab">
              <v-card flat>
                <task
                  :customer_id="tasks[i].customer_id"
                  :url="tasks[i].url"
                  :check_optimization="tasks[i].check_optimization"
                  :check_screenshot="tasks[i].check_screenshot"
                  :check_countwords="tasks[i].check_countwords"
                  :optimizations="tasks[i].optimizations"
                >
                </task>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>

import {
  mapMutations,
} from 'vuex'
import LocalesMixin from './mixins/locales'
import FileReader from "@/utils/file/components/FileReader"
import Task from "./components/Task"
import { Auth, API, graphqlOperation } from 'aws-amplify'
import { createOpticheckTask } from '@/graphql/mutations'

export default {
  mixins: [
    LocalesMixin,
  ],
  components: {
    FileReader,
    Task
  },
  computed: {
    tabVisible () {
      return this.tabs.length > 0;
    },
    saveBtn () {
      return this.$t('save')
    }
  },
  data () {
    return {
      pageTitle: 'opticheck.import',
      activeTabHeader: null,
      activeTab: null,
      tabs: [],
      tabTitles: [],
      tasks: [],
      clearFileReader: false,
    }
  },
  methods: {
    ...mapMutations('app', ['setPage']),
    save () {
      Auth.currentSession().then(result => {
        let promises = []
        for (let i=0; i<this.tasks.length; i++) {
          let promise = API.graphql(graphqlOperation(createOpticheckTask, { input: this.tasks[i] }))
          promises.push(promise)
        }
        Promise.all(promises)
          .then(response => {
            this.$store.dispatch('openAlertBox', [
              'alertSuccess',
              'Success',
            ], { root: true })
            this.clearOpticheck()
          })
          .catch(error => {
            this.$store.dispatch('openAlertBox', [
              'alertError',
              'Error',
            ], { root: true })
          })
      })
    },
    clearOpticheck () {
      this.activeTabHeader = null
      this.activeTab = null
      this.tasks = []
      this.tabs = []
      this.tabTitles = []
      this.clearFileReader = !this.clearFileReader
    },
    parseOpticheck (file) {

      const lines = file.split(/\r\n|\n/)

      // Erste Zeile 27238 - www.bizit.de - Starter SEO Lokal
      let line = lines[0]
      let info = line.split(" - ")
      let contractId = parseInt(info[0])
      let domain = info[1]
      if (!domain.startsWith('http://') || !domain.startsWith('https://')) {
        domain = 'https://' + domain
      }
      let product = info[2]

      console.info("contractId: " + contractId)
      console.info("domain: " + domain)
      console.info("product: " + product)

      let task = {
        url: domain,
        optimizations: [],
        customer_id: contractId,
        check_optimization: true,
        check_screenshot: false,
        check_countwords: false
      }

      let tab = ""
      let tabTitle = ""

      for (let i = 0; i < lines.length; i++) {

        let line = lines[i]
        if (line === "Diese Meta-Angaben wurden in den Header-Bereich Ihrer Startseite eingepflegt (zwischen <head> und </head>):") {
          i += 3
          while (lines[i].trim() !== "") {
            task.optimizations.push({text: lines[i]})
            i += 1
          }
        }
        if (line === "Startseitentext (bitte den alten durch diesen neuen Text ersetzen bzw. ergänzen)") {
          tabTitle = "Startseite"
          tab = "homepage"
          i += 2
          let optimization = ""
          while (!lines[i].trim().startsWith('###')) {

            if (lines[i].trim() === "" || lines[i].trim().startsWith('<!--')) {
              if (optimization) {
                task.optimizations.push({text: optimization})
              }
              optimization = ""
            }
            if (lines[i].trim() !== "" &&
            !lines[i].trim().startsWith('<!--') &&
            !lines[i].trim().startsWith('</div>') &&
            !lines[i].trim().startsWith('<div id="startseitentext">') ) {
              optimization += lines[i].trim()
            }
            i += 1
          }

          this.tasks.push(task)
          this.tabs.push(tab)
          this.tabTitles.push(tabTitle)
        }

        if (line.startsWith("Landing Page ")) {
          task = {
            customer_id: contractId,
            url: null,
            optimizations: [],
            check_optimization: true,
            check_screenshot: true,
            check_countwords: true
          }
          tabTitle = line.replace(':', '')
          tab = line.replace(' ', '').replace(' ', '').replace(':', '').toLowerCase()
          task.url = lines[i+2]
          i += 4
          let optimization = ""
          while (!lines[i].trim().startsWith('_________________________________________________________________')) {

            if (lines[i].trim() === "" || lines[i].trim().startsWith('<!--')) {
              if (optimization) {
                task.optimizations.push({text: optimization})
              }
              optimization = ""
            }
            if (lines[i].trim() !== "" &&
            !lines[i].trim().startsWith('<!--') &&
            !lines[i].trim().startsWith('</div>') &&
            !lines[i].trim().startsWith('<div id="startseitentext">') ) {
              optimization += lines[i].trim()
            }
            i += 1
          }

          this.tasks.push(task)
          this.tabs.push(tab)
          this.tabTitles.push(tabTitle)
        }
        // console.log(line);
      }

      // console.log(this.tabs)
      console.log("activeTab: " + this.tabs[0])
      this.activeTabHeader=0
      this.activeTab=this.tabs[0]
    },
  },
  created () {
    this.setPage(this.pageTitle)
  },
  i18n: {
    messages: {
      de: {
        save: 'Speichern'
      },
      en: {
        save: 'Save'
      },
    },
  },
}

</script>
